<template>
  <div class="payment__card">
    <the-mask :mask="'#### #### #### ####'" placeholder="НОМЕР КАРТЫ" />
    <div class="payment__card-footer">
      <the-mask :mask="'##'" placeholder="ММ" />
      <span>/</span>
      <the-mask :mask="'##'" placeholder="ГГ" />
      <div class="payment__card-cvc">
        <span>
          Три цифры на обороте карты
        </span>
        <the-mask :mask="'###'" placeholder="CVC" />
      </div>
    </div>
  </div>
</template>

<script>
import { TheMask } from 'vue-the-mask'

export default {
  name: 'Card',
  components: { TheMask }
}
</script>

<style scoped lang="scss">
.payment__card {
  background: $french-gray;
  border-radius: 24px;
  padding: 150px 44px 44px;

  & > input {
    margin-bottom: 38px;

    @include md-and-down {
      margin-bottom: 32px;
    }
  }

  @include md-and-down {
    padding: 64px 24px 24px;
  }

  input {
    background: $whisper;
    border: 2px solid $whisper;
    border-radius: 2px;
    height: 62px;
    line-height: 62px;
    padding: 0 20px;
    font-size: 24px;
    color: $deepdark;
    transition: 0.3s;
    width: 100%;

    @include md-and-down {
      height: 40px;
      font-size: 20px;
    }

    &::placeholder {
      color: $french-gray;
    }

    &:focus,
    &:hover {
      border-color: $curious-blue;
    }
  }

  &-cvc {
    display: flex;
    align-items: center;

    @include md-and-down {
      flex: 1;
      justify-content: flex-end;
    }

    span {
      font-size: 14px;
      line-height: 140%;
      display: flex;
      text-align: right;
      margin-right: 8px;
      color: $whisper;

      @include md-and-down {
        display: none;
      }
    }
  }

  &-footer {
    display: flex;
    align-items: center;

    & > span {
      display: block;
      margin: 0 5px;
      color: $whisper;
      font-size: 28px;
    }

    input {
      text-align: center;
      width: 116px;

      @include lg-and-down {
        width: 72px;
        padding: 0 8px;
      }
    }
  }
}
</style>
